import { Bar } from "react-chartjs-2";

// Chart.js Configuration
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default function Roi() {
  const data = {
    labels: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    datasets: [
      {
        label: "2024",
        data: [3, 5, 7, 8, 11, 14, 17, 19, 25, 29, 34, 36],
        backgroundColor: "#1c2226", // Secondary Bar Color
      },
      {
        label: "2025",
        data: [5, 7, 9, 10, 13, 17, 18, 22, 28, 34, 37, 41],
        backgroundColor: "#697d8e", // Secondary Bar Color
      },
    ],
  };
  // Chart options
  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: "top",
      },
      title: {
        display: true,
        text: "Return On Investment (2024)",
        color: "#697d8e",
        font: {
          size: 16,
        },
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#697d8e",
        },
      },
      y: {
        ticks: {
          color: "#697d8e",
        },
      },
    },
  };
  return (
    <div>
      <div className="py-4">
        <div className="chart-container w-full mx-auto">
          <Bar data={data} options={options} />
        </div>
      </div>
    </div>
  );
}
